module.exports = __webpack_public_path__ + "static/media/card.af10ca69.png";